<template>
    <div class="mk-settingshow col-12 p-0">

      <div class="container-fluid mb-4 px-0">
        <div class="row mx-0">

          <div class="col-12 px-0">
            <div class="setting-card dashboard-card">

              <div
                class="
                  mb-4
                  px-0
                  d-flex
                  flex-column flex-md-row
                  justify-content-start justify-content-md-between
                  align-items-md-center align-items-start
                "
              >
                <h3 class="ml-0 mb-0 mb-3">Settings</h3>
              </div>

              <paginated-table :headers="headers" ref="paginationRef">
              </paginated-table>

              <v-dialog v-model="dialog" max-width="600px" scrollable overlay-opacity="0.8" overlay-color="#000">
                <v-card class="mk-org-galleries-modal hf-dialog">
                  <v-card-title>
                    <div
                      class="
                        w-100
                        d-flex
                        justify-content-between
                        align-items-center
                      "
                    >
                      <h2 class="mb-0">
                        Edit {{ setting.name }} Setting
                      </h2>

                      <button
                        @click="dialog = false"
                        class="btn btn-close-modal"
                        text
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </v-card-title>

                  <v-card-text class="py-0">
                    <v-container class="admin-input-wrap">
                        <v-row>
                            <v-col
                                cols="12"
                                class="d-flex justify-content-between align-items-start"
                            >
                                <v-switch
                                :label="enabledStatus"
                                v-model="setting.is_enabled"
                                inset
                                color="var(--color-green)"
                                ></v-switch>
                            </v-col>
                        </v-row>

                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-container>
                      <v-row>
                        <v-col cols="12">
                          <div
                            class="
                              d-flex
                              justify-content-between
                              align-items-center
                            "
                          >
                            <button
                              @click="dialog = false"
                              class="btn btn-grey"
                              text
                            >
                              Cancel
                            </button>

                            <button
                              @click="saveItem"
                              color="primary"
                              text
                              class="btn btn-success"
                            >
                              Save
                            </button>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import Setting from "../../models/Setting";

  export default {
    props: {
      settings: {
        type: Array,
      },
    },
    computed: {
    enabledStatus: function () {
      return this.setting.is_enabled ? "Enabled" : "Disabled";
    }
  },
    data() {
      return {
        headers: [
          { text: "Name", value: "name" },
          { text: "Is Enabled", value: "is_enabled_text" },
          { text: "Actions", value: "actions", sortable: false, hideRemove: true },
        ],
        dialog: false,
        setting: new Setting({}),
      };
    },
    methods: {
      async getModelDetails() {
        return Setting;
      },

      saveItem() {
        this.setting.save().then((response) => {
          if (!response.data) {
            this.dialog = false;
            this.$refs.paginationRef.readDataFromAPI();
          }
        });
      },

      editItem(data) {
        this.dialog = true;
        this.setting = data;
      },

    },
  };
  </script>
